export default __webpack_public_path__ + "static/media/Image13.ac03ac0b.png";